import moment from 'moment'
export default {
  formatPhone: str => `+7 (${str.slice(2,5)}) ${str.slice(5,8)}-${str.slice(8,10)}-${str.slice(10-12)}`,
  // eslint-disable-next-line no-useless-escape
  unformatPhone: str => str.replace(/[\(\)\-\s]/g, ''),
  formatSum: sum => String(sum).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 '),
  calcAge: date => moment().diff(date, 'years'),
}
